"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var __jsx = _react.default.createElement;

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__Wrapper",
  componentId: "sc-1drjc3h-0"
})(["\n  width: 100%;\n  height: ", ";\n  background-color: #fff;\n  display: grid;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-gap: ", "px;\n\n\n  &, & * {\n    box-sizing: border-box;\n  }\n"], function (props) {
  return props.height;
}, function (props) {
  return props.hasYAxis ? "min-content auto" : "auto";
}, function (props) {
  return props.hasXAxis ? "auto 40px" : "auto";
}, function (props) {
  return props.gap;
});

var YAxis = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__YAxis",
  componentId: "sc-1drjc3h-1"
})(["\n  grid-column: 1 / span 1;\n  grid-row: 1 / span 1;\n\n  display: grid;\n  grid-template-columns: auto;\n  grid-template-rows: repeat(", ", 1fr);\n  grid-gap: ", "px;\n"], function (props) {
  return props.steps;
}, function (props) {
  return props.gap;
});

var XAxis = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__XAxis",
  componentId: "sc-1drjc3h-2"
})(["\n  grid-column: ", " / span 1;\n  grid-row: 2 / span 1;\n\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-template-rows: auto;\n  grid-gap: ", "px;\n"], function (props) {
  return props.hasYAxis ? 2 : 1;
}, function (props) {
  return props.count;
}, function (props) {
  return props.gap;
});

var CrossAxis = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__CrossAxis",
  componentId: "sc-1drjc3h-3"
})(["\n  grid-column: 1 / span 1;\n  grid-row: ", " / span 1;\n"], function (props) {
  return props.hasXAxis ? 2 : 1;
});

var Chart = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__Chart",
  componentId: "sc-1drjc3h-4"
})(["\n  grid-column: ", " / span 1;\n  grid-row: 1 / span 1;\n\n  display: grid;\n  grid-template-columns: repeat(", ", 1fr);\n  grid-template-rows: auto;\n  grid-gap: ", "px;\n"], function (props) {
  return props.hasYAxis ? 2 : 1;
}, function (props) {
  return props.count;
}, function (props) {
  return props.gap;
});

var YLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__YLabel",
  componentId: "sc-1drjc3h-5"
})(["\n  line-height: 0px;\n  text-align: right;\n  font-size: 10px;\n  margin-top: -3px;\n"]);

var XLabel = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__XLabel",
  componentId: "sc-1drjc3h-6"
})(["\n  text-align: center;\n  font-size: 7px;\n  overflow: hidden;\n  color: ", ";\n\n"], function (props) {
  return props.color ? props.color : "#303030";
});

var ChartCol = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__ChartCol",
  componentId: "sc-1drjc3h-7"
})(["\n\n  display: grid;\n  grid-template-columns: auto;\n  grid-template-rows: repeat(", ", 1fr);\n  grid-gap: ", "px;\n\n    & span{\n      display: none;\n      position: absolute;\n      white-space: nowrap;\n      top: -20px;\n      text-align: center;\n      font-size: 10px;\n      letter-spacing: 0px;\n\n      margin-left: 50%;\n      transform: translateX(-50%);\n\n      z-index: 9;\n    }\n    &:hover span{\n      display: block;\n    }\n"], function (props) {
  return props.steps;
}, function (props) {
  return props.gap;
});

var ChartBlock = _styledComponents.default.div.withConfig({
  displayName: "OzChartHistocalendar__ChartBlock",
  componentId: "sc-1drjc3h-8"
})(["\n  position: relative;\n  background: ", ";\n  grid-row: ", ";\n"], function (props) {
  return props.color + (props.opacity !== "FF" ? props.opacity : "");
}, function (props) {
  return props.position;
});

var OzChartHistocalendar = function OzChartHistocalendar(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? "300px" : _ref$height,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "#687fe2" : _ref$color,
      _ref$voidColor = _ref.voidColor,
      voidColor = _ref$voidColor === void 0 ? "#FBFBFF" : _ref$voidColor,
      _ref$minOpacity = _ref.minOpacity,
      minOpacity = _ref$minOpacity === void 0 ? 0 : _ref$minOpacity,
      _ref$maxOpacity = _ref.maxOpacity,
      maxOpacity = _ref$maxOpacity === void 0 ? 1 : _ref$maxOpacity,
      max = _ref.max,
      steps = _ref.steps,
      values = _ref.values,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? 5 : _ref$gap,
      style = _ref.style,
      fnCallback = _ref.fnCallback,
      _ref$fnFormatValue = _ref.fnFormatValue,
      fnFormatValue = _ref$fnFormatValue === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatValue,
      _ref$fnFormatY = _ref.fnFormatY,
      fnFormatY = _ref$fnFormatY === void 0 ? function (ret) {
    return ret;
  } : _ref$fnFormatY;
  var maxY = max ? max : Math.max.apply(Math, (0, _toConsumableArray2.default)(values.map(function (item) {
    return item.value;
  })));
  var rangeOpacity = maxOpacity - minOpacity;
  var letMaxYLength = parseInt(maxY).toString().length;

  if (letMaxYLength > 2) {
    maxY = (parseInt(maxY.toString().substring(0, 2)) + 1) * Math.pow(10, letMaxYLength - 2);
  } else {
    maxY = (parseInt(maxY.toString().substring(0, 1)) + 1) * Math.pow(10, letMaxYLength - 1);
  }

  if (!steps) {
    for (var i = 10; i > 2; i--) {
      if (maxY * 2 % i === 0) {
        steps = i;
        break;
      }
    }

    if (!steps) {
      steps = 10;
    }
  }

  var labelsY = [];
  var stepY = maxY / steps;

  for (var _i = steps; _i >= 0; _i--) {
    if (stepY < 1) {
      labelsY.push((_i * stepY).toFixed(1));
    } else {
      labelsY.push(_i * stepY);
    }
  }

  return __jsx(Wrapper, {
    height: height,
    gap: gap,
    hasXAxis: !(style && style.xAxis && !style.xAxis.showLabels),
    hasYAxis: !(style && style.yAxis && !style.yAxis.showLabels)
  }, !(style && style.yAxis && !style.yAxis.showLabels) ? __jsx(_react.default.Fragment, null, __jsx(CrossAxis, {
    hasXAxis: !(style && style.xAxis && !style.xAxis.showLabels)
  }, __jsx(YLabel, null, fnFormatY(labelsY[labelsY.length - 1]))), __jsx(YAxis, {
    steps: steps,
    gap: gap,
    hasXAxis: !(style && style.xAxis && !style.xAxis.showLabels)
  }, labelsY.map(function (item, i) {
    return i !== labelsY.length - 1 ? __jsx(YLabel, {
      key: i
    }, fnFormatY(item)) : null;
  }))) : null, !(style && style.xAxis && !style.xAxis.showLabels) ? __jsx(XAxis, {
    count: values.length,
    gap: gap,
    hasYAxis: !(style && style.yAxis && !style.yAxis.showLabels)
  }, values.map(function (item, i) {
    return __jsx(XLabel, {
      key: i,
      color: item.style && item.style.labelColor ? item.style.labelColor : null
    }, fnFormatY(item.label));
  })) : null, __jsx(Chart, {
    count: values.length,
    gap: gap,
    hasXAxis: !(style && style.xAxis && !style.xAxis.showLabels),
    hasYAxis: !(style && style.yAxis && !style.yAxis.showLabels)
  }, values.map(function (item, i) {
    return __jsx(ChartCol, {
      steps: steps,
      gap: gap,
      key: i
    }, labelsY.map(function (maxY, j) {
      return item.value && item.value >= maxY ? __jsx(ChartBlock, {
        key: i + "-" + j,
        steps: steps,
        position: j + 1,
        color: item.style && item.style.blockColor ? item.style.blockColor : color,
        opacity: (maxOpacity * 255).toString(16)
      }, item.value && item.value === maxY ? __jsx("span", null, fnFormatValue(item.value)) : null) : item.value > labelsY[j + 1] ? __jsx(ChartBlock, {
        key: i + "-" + j,
        steps: steps,
        position: j + 1,
        color: item.style && item.style.blockColor ? item.style.blockColor : color,
        opacity: Math.floor(((item.value - labelsY[j + 1]) * rangeOpacity / (labelsY[j] - labelsY[j + 1]) + minOpacity) * 255).toString(16)
      }, item.value ? __jsx("span", null, fnFormatValue(item.value)) : null) : __jsx(ChartBlock, {
        key: i + "-" + j,
        color: item.style && item.style.voidBlockColor ? item.style.voidBlockColor : voidColor,
        opacity: "FF"
      });
    }));
  })));
};

var _default = OzChartHistocalendar;
exports.default = _default;